export default __webpack_public_path__ + "static/from-abroad-one-ad35c1006fd99240c30135c997f81d41.jpg";